import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/legal/LegalPage";
import termsSource from "@/content/terms.md?raw";

export const Route = createFileRoute("/terms")({
  component: () => <LegalPage title="Terms of Service" source={termsSource} />,
});
